import React, { useCallback, useContext } from 'react'
import { Avatar, Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import * as Icons from '@ant-design/icons'
import { useQuery } from 'react-query'
import { blue, grey } from '@ant-design/colors'

import { StyledHeader, StyledMenuFoldIcon, StyledMenuUnfoldIcon } from '../styled'
import { useHeader } from '../hooks'
import { StyledHeaderButton, StyledHeaderLeft, StyledHeaderRight, StyledPortalArea } from '../styled/header'
import { CurrentCashRegister } from '../../cash-register/containers/current-device'
import { useAuth } from '@modules/me/hooks'
import { CashboxesService } from '../../cash-flow/cashboxes/services'
import { EmergencyContext } from '../../settings/context'

export const AppHeader = () => {
  const { can, state } = useAuth()
  const { toggleSidebar, sidebarIsOpen, avatarText, logout } = useHeader()
  const { setEmergencyMode } = useContext(EmergencyContext)

  const handleEmergency = useCallback(() => {
    setEmergencyMode()
  }, [setEmergencyMode])

  const cashboxBalance = useQuery('cashbox-balance', async ({ queryKey }) => {
    const result = await CashboxesService.getCurrentBalance()

    if (result.status === 200) {
      return result.data
    } else {
      throw new Error(result.data)
    }
  })

  const menuItems: MenuProps['items'] = [
    cashboxBalance.data && {
      key: 'balance',
      label: `${cashboxBalance.data.name}: ${cashboxBalance.data.amount} AZN`,
      icon: <Icons.MoneyCollectOutlined />,
      disabled: true,
      style: { color: 'black' },
    },
    {
      key: 'logout',
      label: 'Çıxış',
      icon: <Icons.LogoutOutlined />,
      onClick: logout,
    },
  ].filter(Boolean) as MenuProps['items']

  return (
    <StyledHeader $wide={!sidebarIsOpen}>
      <StyledHeaderLeft>
        {sidebarIsOpen ? <StyledMenuFoldIcon onClick={toggleSidebar} /> : <StyledMenuUnfoldIcon onClick={toggleSidebar} />}
      </StyledHeaderLeft>
      <StyledPortalArea />
      <StyledHeaderRight>
        {can(97) && can(98) && <CurrentCashRegister />}
        <Dropdown menu={{ items: menuItems }}>
          <StyledHeaderButton onDoubleClick={handleEmergency}>
            <Avatar style={{ backgroundColor: !!state.user?.data?.emergencyMode ? blue[7] : grey[1] }}>{avatarText}</Avatar>
          </StyledHeaderButton>
        </Dropdown>
      </StyledHeaderRight>
    </StyledHeader>
  )
}
